import axios from '@/utils/axios';

const userApi = {
  list: '/skill/list',
  detail: id => `/skill/${id}`,
  versions: id => `/skill/${id}/versions`,
  installPrompt: versionId => `/skill/version/${versionId}/install-prompt`,
};

const adminApi = {
  list: '/skill/admin/list',
  save: '/skill/admin/save',
  uploadVersion: '/skill/admin/version/upload',
  updateVersion: '/skill/admin/version/update',
  publishVersion: id => `/skill/admin/version/${id}/publish`,
  disableVersion: id => `/skill/admin/version/${id}/disable`,
  deleteSkill: id => `/skill/admin/${id}/delete`,
  downloadLogs: '/skill/admin/download/logs',
};

export function getSkillList(params) {
  return axios.get(userApi.list, { params });
}

export function getSkillDetail(id) {
  return axios.get(userApi.detail(id));
}

export function getSkillVersions(id) {
  return axios.get(userApi.versions(id));
}

export function getInstallPrompt(versionId, apiBaseUrl) {
  return axios.get(userApi.installPrompt(versionId), { params: { apiBaseUrl } });
}

export function downloadSkill(versionId) {
  return `${process.env.VUE_APP_BASE_URL}/skill/version/${versionId}/download`;
}

export function getAdminSkillList(params) {
  return axios.get(adminApi.list, { params });
}

export function saveSkill(params) {
  return axios.post(adminApi.save, params);
}

export function uploadSkillVersion({ file, skillId, version, supportedAgents }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('skillId', skillId);
  formData.append('version', version);
  if (supportedAgents?.length) {
    formData.append('supportedAgents', supportedAgents.join(','));
  }
  return axios.post(adminApi.uploadVersion, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateSkillVersion(params) {
  return axios.post(adminApi.updateVersion, params);
}

export function publishSkillVersion(id) {
  return axios.post(adminApi.publishVersion(id));
}

export function disableSkillVersion(id) {
  return axios.post(adminApi.disableVersion(id));
}

export function deleteSkill(id) {
  return axios.post(adminApi.deleteSkill(id));
}

export function getSkillDownloadLogs(params) {
  return axios.get(adminApi.downloadLogs, { params });
}
